import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../../data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AdditionalWezw = (props) => {
  const [content, setContent] = useState("");
  const [status, setStatus] = useState("");
  const [statusNote, setStatusNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState(+props.clientId);
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusOptionsHearings, setStatusOptionsHearings] = useState([]);

  const handleStatusNoteChange = (e) => {
    setStatusNote(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.value);
  };

  useEffect(() => {
    setStatusOptions(createStatusOptions());
    setStatusOptionsHearings(createStatusOptionsHearing());
  }, []);

  const addClientContact = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        status: status,
        status_note: statusNote,
        id: clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Zmieniono status sprawy klienta", props.clientId);

      props.close();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const createStatusOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({
      label: "mamy wezwanie - pozew gotowy do pisania",
      value: "mamy wezwanie - pozew gotowy do pisania",
    });
    statusOptions.push({
      label: "mamy wezwanie - braki dokumentowe klienta",
      value: "mamy wezwanie - braki dokumentowe klienta",
    });

    return statusOptions;
  };

  const createStatusOptionsHearing = (e) => {
    var statusOptions = [];
    statusOptions.push({
      label: "wygrana w II instancji",
      value: "wygrana w II instancji",
    });
    statusOptions.push({
      label: "przegrana w II instancji",
      value: "przegrana w II instancji",
    });
    statusOptions.push({
      label: "I instancja po uchyleniu",
      value: "I instancja po uchyleniu",
    });
    statusOptions.push({ label: "ugoda", value: "ugoda" });

    return statusOptions;
  };

  const validatePayment = (e) => {
    if (status.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id="popUpLoading" />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div style={{ width: "100%" }} className="inputCol_3">
                <label>
                  Status sprawy <span className="requiredStar">*</span>
                </label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  options={
                    props.place === "hearing"
                      ? statusOptionsHearings
                      : statusOptions
                  }
                  onChange={handleStatusChange}
                />
              </div>
            </div>

            <div className="inputBox">
              {status === "mamy wezwanie - braki dokumentowe klienta" ? (
                <>
                  <div style={{ width: "100%" }} className="inputCol_3">
                    <label>
                      Notatka do statusu <span className="requiredStar">*</span>
                    </label>
                    <textarea
                      spellCheck="false"
                      className="textAreaNote"
                      type="text"
                      id="url"
                      name="url"
                      value={statusNote}
                      onChange={handleStatusNoteChange}
                    />
                  </div>
                </>
              ) : (
                ""
              )}
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addClientContact}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdditionalWezw;
